function Algeria({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_521_478)">
        <path d="M16 0C24.8365 0 32 7.1635 32 16C32 24.8365 24.8365 32 16 32C16 31.3044 13.9131 16 13.9131 16L16 0Z" fill="#F0F0F0"/>
        <path d="M16 32C7.1635 32 0 24.8365 0 16C0 7.1635 7.1635 0 16 0" fill="#496E2D"/>
        <path d="M19.4376 12.9307L18.1248 14.7397L15.9988 14.0502L17.3137 15.8577L16.001 17.6668L18.1263 16.9749L19.4412 18.7823L19.4398 16.5472L21.5651 15.8552L19.4391 15.1659L19.4376 12.9307Z" fill="#D80027"/>
        <path d="M17.3273 20.5216C14.83 20.5216 12.8055 18.4971 12.8055 15.9998C12.8055 13.5026 14.83 11.4781 17.3273 11.4781C18.1059 11.4781 18.8386 11.6749 19.4782 12.0216C18.4747 11.0403 17.1024 10.4346 15.5881 10.4346C12.5145 10.4346 10.0229 12.9262 10.0229 15.9998C10.0229 19.0733 12.5146 21.5649 15.5881 21.5649C17.1025 21.5649 18.4748 20.9593 19.4782 19.9779C18.8386 20.3247 18.1059 20.5216 17.3273 20.5216Z" fill="#D80027"/>
      </g>
    </svg>
  `;

  return baseXml;
}

export default Algeria;
